import css from "../../pages/SuspensionPage/SuspensionPage.module.css";
export default function Intro() {
  return (
    <div className={css.intro}>
      <h2>Suspension Diagnosis and Repair: Ensuring a Smooth and Safe Ride</h2>

      <p>
        At Wheeltex, we are specialized in comprehensive suspension diagnosis
        and repair services, helping you maintain optimal vehicle performance,
        safety and comfort. Your suspension is the backbone of your ride,
        absorbing shocks from the road, supporting weight, and ensuring stable
        handling. Over time, wear and tear from daily driving, potholes, or
        off-road use can lead to the issues that compromise your driving
        experience. That’s where our expert team comes in.
      </p>
    </div>
  );
}
